import { yupResolver } from '@hookform/resolvers/yup'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import FieldV2 from 'src/components/FormComponents/FieldV2'
import Form from 'src/components/FormComponents/Form'
import Submit from 'src/components/FormComponents/Submit'
import { selectProductTabFilters } from 'src/features/stock-management/StockManagementSeletor'
import { actions } from 'src/features/stock-management/StockManagementState'
import * as S from './MovementsByTypeForm.styles'
import { schema } from './MovementsByTypeForm.schema'
import { MovementsTabFormValue } from './MovementsByTypeForm.types'

export default () => {
  const {
    control,
    handleSubmit,
  } = useForm<MovementsTabFormValue>({
    resolver: yupResolver(schema),
  })
  const dispatch = useDispatch()
  const productTabFilters = useSelector(selectProductTabFilters)

  const onSubmit: SubmitHandler<MovementsTabFormValue> = (data) => {
    dispatch(actions.clearMovementsByTypeTab())
    dispatch(actions.setProductTabsFilters({ ...productTabFilters, ...data }))
    dispatch(actions.getProductMovementsByType())
  }

  return (
    <S.Form as={Form} onSubmit={handleSubmit(onSubmit)}>
      <S.Field
        as={FieldV2}
        labelText='Mês início:'
        name='startDate'
        control={control}
        type='month'
      />
      <S.Field
        as={FieldV2}
        labelText='Mês fim:'
        name='endDate'
        control={control}
        type='month'
      />
      <S.Submit as={Submit} disabled={false} text='Buscar'/>
    </S.Form>
  )
}
